export const getOfferPercent = (offer) => {
  const percent = Number(String(offer ?? "").replace(/[^0-9.]/g, ""));
  if (!Number.isFinite(percent) || percent <= 0) return 0;
  return Math.min(percent, 100);
};

export const getDiscountedPrice = (price, offer) => {
  const basePrice = Number(price);
  const percent = getOfferPercent(offer);

  if (!Number.isFinite(basePrice) || basePrice <= 0) return 0;
  if (!percent) return basePrice;

  return Number((basePrice - (basePrice * percent) / 100).toFixed(2));
};
